import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import CardDsfrContext from "components/CardDsfrContext";
import DSFRListContext from "components/DSFRListContext";
import BadgeToDisplay from "components/templatesComponents/BadgeToDisplay";
import DateToDisplay from "components/templatesComponents/DateToDisplay";
import Link from "components/templatesComponents/Link";
import { useGetAllSites } from "hooks/site.hook";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";

const DSFRCard = (props) => {
  const { link = {}, title, description, site: siteName, titleSize = "md" } = props;
  const { page: pageVersion = null, url, external, title: titleLink } = link || {};
  const { fullPath, page = {}, image } = pageVersion || {};
  const { siteId, firstPublishedDate } = page || {};
  const { props: imageProps } = image || {};
  const { file, alt = "" } = imageProps || {};
  const { url: imageUrl } = file || {};

  const { highlighted, isHorizontal, showImage, showBadge, showDetail, hasGreyBackground, showDescription } =
    useContext(CardDsfrContext);
  const { xs, sm, lg } = useContext(DSFRListContext);

  const { data: allSites = [] } = useGetAllSites();

  const findSiteById = useMemo(() => allSites?.find((site) => site.id === siteId), [allSites, siteId]);

  const { host } = findSiteById || {};

  const isBoFullPath =
    fullPath && fullPath.includes("site=") && fullPath.includes("page=") && fullPath.includes("version=");

  const linkUrl = useMemo(() => {
    if (url) {
      return url;
    }
    if (!isBoFullPath && host) {
      return `${host}${fullPath}`;
    }
    return fullPath;
  }, [url, isBoFullPath, host, fullPath]);

  const colorClass = useMemo(() => {
    switch (siteName) {
      case "IMMAT":
      case "PHA":
        return "orange-terre-battue";
      case "PERMIS":
      case "AUTO_ECOLE":
        return "purple-glycine";
      case "PASSEPORT_CNI":
      case "MAIRIE":
        return "green-archipel";
      default:
        return "info";
    }
  }, [siteName]);

  let cardClassName = "fr-card fr-enlarge-link";
  if (titleSize === "sm") {
    cardClassName += " fr-card--sm";
  }
  if (isHorizontal) {
    cardClassName += " fr-card--horizontal-tier";
  }
  if (hasGreyBackground) {
    cardClassName += " fr-card--grey";
  }

  return (
    <Grid size={{ xs, sm, lg }} component="li">
      <div className={cardClassName}>
        <div className="fr-card__body">
          <div className="fr-card__content">
            <h4 className="fr-card__title">
              <Link basic button url={linkUrl} title={titleLink} external={external} sx={{ wordBreak: "break-word" }}>
                {title}
              </Link>
            </h4>
            {(highlighted || showBadge || showDetail) && (
              <div className="fr-card__start">
                {firstPublishedDate && showDetail && <DateToDisplay pageVersion={pageVersion} />}
                {showBadge && <BadgeToDisplay label={siteName} color={colorClass} />}
                {highlighted && <BadgeToDisplay label="highlighted" color={colorClass} />}
              </div>
            )}
            {showDescription && description && (
              <Box
                component="p"
                className="fr-card__desc"
                sx={{
                  display: "-webkit-box",
                  "-webkit-line-clamp": "5",
                  "-webkit-box-orient": "vertical",
                  overflow: "hidden",
                }}
              >
                {description}
              </Box>
            )}
          </div>
        </div>
        {showImage && imageUrl && (
          <div className="fr-card__header">
            <div className="fr-card__img">
              <img className="fr-responsive-img" src={imageUrl} alt={alt} style={{ objectFit: "unset" }} />
            </div>
          </div>
        )}
      </div>
    </Grid>
  );
};

DSFRCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.shape(),
  site: PropTypes.string,
  titleSize: PropTypes.string,
};

export default DSFRCard;
